<template>
  <div class='notice atb-flex atb-flex-column'>
    <div class='atb-content-bg atb-flex atb-flex-column'>
      <div class='search'>
        <el-form :inline="true" :model="declareForm" class="atb-input" @keyup.enter.native.prevent="getList(1)" @submit.native.prevent>
          <div class="query-where">
            <el-form-item class="flex-form-item" label="部门名称" prop="departmentNo">
              <el-popover
                placement="bottom-start"
                width="420"
                popper-class="popper-tree declare-dep"
                @hide="handledHide"
                trigger="click">
                <!-- <el-input v-model="searchDep" placeholder="请输入部门名称搜索" clearable></el-input> -->
                <el-tree
                  :props="defaultProps"
                  :data="treeData"
                  show-checkbox
                  node-key='id'
                  ref="tree"
                  highlight-current
                  :default-expanded-keys="expandedData"
                  @check="handleCheckChange">
                </el-tree>
                <el-input slot="reference" v-model="department" placeholder="请选择部门" clearable></el-input>
              </el-popover>
            </el-form-item>
            <!-- <el-form-item class="flex-form-item" label="上级">
              <el-input v-model="declareForm.SuperiorName" placeholder="上级" clearable></el-input>
            </el-form-item> -->
            <el-form-item class="flex-form-item" label="上级">
              <selecter v-model="declareForm.SuperiorNo" placeholder="输入工号或姓名查询" @selecterData="getSelecterData" :name="declareForm.SuperiorName"></selecter>
            </el-form-item>
            <el-form-item class="flex-form-item" label="姓名">
              <el-input v-model="declareForm.WkName" placeholder="姓名" clearable></el-input>
            </el-form-item>
            <el-form-item class="flex-form-item" label="OEC评定结果">
              <el-select clearable v-model="declareForm.OecResult" placeholder="OEC评定结果">
                <el-option v-for="item in oecLevel" :key="item.value" :label="item.label" :value="item.label"></el-option>
              </el-select>
            </el-form-item>
          </div>
          <div class="query-operation">
            <el-form-item class="flex-form-item" label="月份">
              <el-date-picker
                v-model="declareForm.month"
                type="month"
                value-format="yyyy-MM"
                placeholder="选择月">
              </el-date-picker>
            </el-form-item>
            <el-form-item class="flex-form-item" label="状态">
              <common-select ref="status" v-model="declareForm.Status" :list="OecStatusList" optLabel="itemDesc" optValue="itemValue" placeholder="状态" clearable></common-select>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="getList(1)">查询</el-button>
            </el-form-item>
            <el-form-item>
              <el-button type="export" v-if="$auth(that, 'Publicity')" @click="confirmTip">公示</el-button>
            </el-form-item>
            <el-form-item>
              <el-button type="export" @click="exportExcel">导出</el-button>
            </el-form-item>
            <el-form-item>
              <el-button type="downloadTemplate" @click="exportMulti">批量导出</el-button>
            </el-form-item>
            <el-form-item>
              <el-upload ref="file" :http-request="uploadPublishFile" :multiple="false" :show-file-list="false">
                <el-button type="downloadTemplate">导入公示</el-button>
              </el-upload>
            </el-form-item>
            <el-form-item>
              <el-button type="downloadTemplate" @click="downloadPublishTemplate" style="width: 110px!important;">下载公示模板</el-button>
            </el-form-item>
            <el-form-item>
              <el-button type="export" v-if="$auth(that, 'DeclareRemind')" @click="declareRemind">申报提醒</el-button>
            </el-form-item>
            <el-form-item>
              <el-button type="export" v-if="$auth(that, 'ApprovalRemind')" @click="confirmRemind">审批提醒</el-button>
            </el-form-item>
          </div>
        </el-form>
      </div>
      <div class='table-content'>
        <vxe-table
          stripe
          class='atb-table header-table edit-table'
          border='inner'
          height='100%'
          auto-resize
          resizable
          highlight-hover-row
          :data="tableData"
          ref="unHandle"
          @cell-click="expandRow"
          :seq-config="{seqMethod}"
        >
          <vxe-table-column type="seq" width="60" title="NO."></vxe-table-column>
          <vxe-table-column field="wk" width="150" title="姓名">
            <template #default="{ row }"><span>{{row.wkName? row.wkName + "("+row.wkNo+")": row.wkNo}}</span>
            </template>
          </vxe-table-column>
          <vxe-table-column field="superior" width="150" title="上级">
            <template #default="{ row }"><span>{{row.superiorName? row.superiorName + "("+row.superiorNo+")": row.superiorNo}}</span>
            </template>
          </vxe-table-column>
          <vxe-table-column field="department" title="部门" width="220">
             <template #default="{row}">{{row.department}}</template>
          </vxe-table-column>
          <vxe-table-column field="date" title="年/月" width="80">
            <template #default="{row}">{{row.year+'/'+row.month}}</template>
          </vxe-table-column>
          <vxe-table-column field="declareDate" title="时间" width="100">
            <template #default="{row}">
              <span>{{row.creationTime ? XEUtils.toDateString(new Date(row.creationTime), 'yyyy-MM-dd') : ''}}</span>
            </template>
          </vxe-table-column>
          <vxe-table-column width="100" field="ratingResult" title="OEC评级" :edit-render="{name: 'ElSelect',autofocus: '.el-input__inner', enabled: disabled}">
            <template #default="{row}">
              <span>{{row.ratingResult}}</span>
            </template>
            <template #edit="{row}">
              <el-select v-model="row.ratingResult" @change="$refs.unHandle.updateStatus(scope)">
                <el-option v-for="item in oecLevel" :key="item.label" :label="item.label" :value="item.label"></el-option>
              </el-select>
            </template>
          </vxe-table-column>
          <vxe-table-column width="120" field="isRatingInCurrentMonth" title="当月是否参评">
            <template #default="{row}">
              <span>{{row.isRatingInCurrentMonth ? "是" : '否'}}</span>
            </template>
          </vxe-table-column>
          <vxe-table-column min-width="180" field="ratingReason" title="评级原因" :edit-render="{autofocus: '.el-textarea__inner'}">
            <template #edit="{ row }">
              <el-input type='textarea' autosize placeholder="请输入内容" v-model="row.ratingReason"></el-input>
            </template>
            <template #default="{row}">
              <div :class="[row.expandRowFlag ? '' : 'atb-ellipsis', 'flex', 'atb-flex-items-center']">{{row.ratingReason}}
              </div>
            </template>
          </vxe-table-column>
          <vxe-table-column field="remarks" width="160" title="备注" :edit-render="{autofocus: '.el-textarea__inner'}">
            <template #edit="{ row }">
              <el-input type='textarea' autosize placeholder="请输入内容" v-model="row.remarks"></el-input>
            </template>
            <template #default="{row}">
              <div :class="[row.expandRowFlag ? '' : 'atb-ellipsis', 'flex', 'atb-flex-items-center']">{{row.remarks}}
              </div>
            </template>
          </vxe-table-column>
          <vxe-table-column field="status" title="状态" fixed="right" min-width="120" show-overflow>
            <template #default="{ row,column }">
              <el-tag type="complete" effect="dark">
                {{ OecStatusList.length>0 && OecStatusList.find(t=>t.itemValue==row[column.property])? OecStatusList.find(t=>t.itemValue==row[column.property]).itemDesc: '' }}
              </el-tag>
            </template>
          </vxe-table-column>
          <vxe-table-column v-if="$auth(that, 'PublicityUpdate')" field="" title="操作" fixed="right" width='100' class-name='operation'>
            <template #default="scope">
              <div>
                <el-tooltip class='item' effect='dark' content='编辑' placement="bottom">
                  <i class='icon-editor' @click.stop='edit({row:scope.row})'></i>
                </el-tooltip>
              </div>
            </template>
          </vxe-table-column>
        </vxe-table>
      </div>
      <div class='page-con atb-flex atb-flex-justify-end'>
        <vxe-pager
          background
          :current-page.sync="page.PageIndex"
          :page-size.sync="page.PageSize"
          :total="total"
          height="100%"
          @page-change="pageChange"
          :page-sizes="[10, 30, 50, 100, 500]"
          :layouts="['PrevJump', 'PrevPage', 'JumpNumber', 'NextPage', 'NextJump', 'Sizes', 'Total']"
        >
        </vxe-pager>
      </div>
    </div>
    <el-dialog title="提示" :visible.sync="showConfirmTip" width="260px" :close-on-click-modal="false" :close-on-press-escape="false">
      <div class="content">
        <h2>确定要公示吗?</h2>
        <p>{{message}}</p>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button class="atb-dialog-confirm" type="primary" @click="confirm">确认</el-button>
        <el-button class="atb-dialog-cancel" type="cancel" @click="showConfirmTip = false">取消</el-button>
      </span>
    </el-dialog>
    <common-dialog ref="addDialog" :title="dialogContent.title" :width="dialogContent.width" showClose :appendBody="true">
      <template slot="content">
        <component v-bind:is="dialogContent.componentName" :editData="EditRow" :param="Object.assign({}, this.declareForm,{departmentNo:this.departmentNo})" @submitSuccess="getList()"></component>
      </template>
    </common-dialog>
  </div>
</template>
<script>
  import XEUtils from 'xe-utils'
  import _ from 'lodash';
  import qs from 'qs';
  export default {
    components: {
     add:()=>import('./add.vue'),
     month:()=>import('./month.vue'),
     selecter:()=>import('@/component/global/customerSelect'),
     DeclareRemind: ()=>import('./DeclareRemind'),
     ApproveRemind: ()=>import('./ApproveRemind'),
    },
    name: "publish",
    data() {
      const ratingReasonValid = ({cellValue,row}) => {
        if (!cellValue && ['A', 'C'].includes(row.ratingResult)) {
          return new Error('评级结果为A、C时必须填写原因！')
        }
      }
      return {
        validRules: {
          ratingReason: [
            { validator: ratingReasonValid }
          ]
        },
        XEUtils: XEUtils,
        enableHandle: true,
        importantList: [
          {label: '否', value: false},
          {label: '是', value: true},
        ],
        oecLevel: [
          {label: 'A'},
          {label: 'B'},
          {label: 'C'},
        ],
        declareForm: {
          WkName: '',
          SuperiorName:'',
          OecResult: '',
          SuperiorNo: ''
        },
        seleterData: {},
        page: {
          PageIndex: 1,
          PageSize: 10
        },
        total: 0,
        tableData: [],
        unHandleList: [],
        handledList: [],
        warnNum:'warn-num',
        nomalNum:'num',
        OecStatusList:[],
        that:this,
        depData:[],
        treeData: [],
        defaultProps: {
          children: 'children',
          label: 'label'
        },
        depList:[],
        checkId:"",
        department:'',
        copyTreeData:[],
        departmentNo:'',
        row:{},
        showConfirmTip:false,
        expandedData:[],
        message:'',
        dialogContent:{},
        selectNode: [],
        publishDownloadUrl: process.env.VUE_APP_PUBLICPATH + 'files/OEC导入公示模板.xlsx',
      }
    },
    created() {
      this.getList();
    },
    mounted() {
      this.getOecStatus();
      this.getDep();
      this.getSimpleCheckedNodes(this.$refs.tree.store);
    },
    methods: {
      // 格式化序列号
      seqMethod({ rowIndex }) {
        return rowIndex + (this.page.PageIndex - 1) * this.page.PageSize + 1;
      },
      getSelecterData(data){
        this.seleterData = data;
      },
      handleClick(tab, event) {
        console.log(tab, event);
      },
      async getList(resetPage) {
       if(resetPage){
         this.page.PageIndex = 1;
       }
       this.declareForm.SuperiorName = this.declareForm.SuperiorNo? this.seleterData.find(t=>t.jobNo==this.declareForm.SuperiorNo).name: '';
       let param = Object.assign({}, this.page, this.declareForm, {departmentNo:this.departmentNo});
       await this.$ajax.get(this.$api.manage.publish.list, param).then((res) => {
          this.tableData = res.data.rows;
          this.total = res.data.total;
        });
      },
      getCurrent(item) {
        this.currentTab = item.data.id;
      },
     async editClosed({row}){
        const $table = this.$refs.unHandle;
        const errMap = await $table.validate(true).catch(errMap => errMap)
        if (errMap) {
          this.$XModal.message({ status: 'error', content: '校验不通过！' })
        } else {
          const {id,ratingResult,ratingReason,remarks} =row.o;
          this.$ajax.post(this.$api.manage.declare.create, {id,ratingResult,ratingReason,remarks}).then(() => {
            this.$message.success("保存成功");
          });
        }
      },
      editActived({row}) {
        //InteriorUpdate:内务更新;LeaderUpdate:领导更新;PersonnelUpdate:行政更新;
        if(row.status === 0 && row.tag===1){
          return true;
        }
        if(row.status===10&&(this.$auth(this, 'PersonnelUpdate')||this.$auth(this, 'InteriorUpdate'))){
          return true;
        }
        return false;
      },
      save() {
        if (this.unHandleList.length) {
          this.$ajax.post(this.$api.manage.declare.createAll, this.unHandleList).then(() => {
            this.$message.success("保存成功");
          });
        }else {
          this.$ajax.post(this.$api.manage.declare.createAll, this.tableData).then(() => {
            this.$message.success("保存成功");
          });
        }
      },
      confirmTip(){
        this.declareForm.SuperiorName = this.declareForm.SuperiorNo? this.seleterData.find(t=>t.jobNo==this.declareForm.SuperiorNo).name: '';
        let param = Object.assign({}, this.page, this.declareForm,{departmentNo:this.departmentNo});
        this.$ajax.get(this.$api.manage.publish.confirmOecTip,param,{noLoading:true}).then((res) => {
          this.message=res.message;
          }).finally(()=>{
            this.showConfirmTip=true;
        });
      },
      confirm() {
        this.declareForm.SuperiorName = this.declareForm.SuperiorNo? this.seleterData.find(t=>t.jobNo==this.declareForm.SuperiorNo).name: '';
        let param = Object.assign({}, this.page, this.declareForm,{departmentNo:this.departmentNo});
        this.$ajax.put(this.$api.manage.publish.confirmOec, param).then(() => {
          this.getList();
          this.$message.success("公示成功");
        }).finally(()=>{
            this.showConfirmTip=false;
        });
      },
      unHandleSelectAll({records}) {
        this.unHandleList = records;
      },
      unHandleSelectChange({records}) {
        this.unHandleList = records;
      },
      pageChange({ currentPage }) {
        this.page.PageIndex = currentPage;
        this.getList();
      },
      async getOecStatus(){
         await this.$ajax.get(this.$api.common.getDict,{ItemType:'OecStatus'}).then((res) => {
            this.OecStatusList=res.data.rows||res.data||[];
         });
      },
      // eslint-disable-next-line no-unused-vars
      expandRow({row, rowIndex}) {
        this.tableData[rowIndex].expandRowFlag = !this.tableData[rowIndex].expandRowFlag;
        this.$refs.unHandle.updateData(this.tableData);
      },
      async getDep() {
       await this.$ajax.get(this.$api.Identity.Categord.dep, {}).then(res => {
          this.depList=res.data||[];     
            const obj ={};
            this.depList.forEach(v=>{
             const objClone=_.cloneDeep(obj);
             objClone.id= v.id,
             objClone.code= v.code,
             objClone.label= v.displayName
           if(v.parentId===null){
              this.expandedData.push(v.id);
              objClone.children= this.depList.filter(t=>t.parentId===v.id);
              this.generateMenu(objClone.children);
              this.treeData.push(objClone);
              this.copyTreeData=_.cloneDeep(this.treeData);
            }
          });
        });
      },
      generateMenu(chs){
        chs.forEach(v=>{
          v.label= v.displayName
          v.children = this.depList.filter(t=>t.parentId === v.id)
          this.generateMenu(v.children);
        });
      },
      getSimpleCheckedNodes(store) {
        const checkedNodes = [];
        const traverse = function(node) {
          const childNodes = node.root ? node.root.childNodes : node.childNodes;
          childNodes.forEach(child => {
            if (child.checked) {
              checkedNodes.push(child.data);
            }
            if (child.indeterminate) {
              traverse(child);
            }
          });
        };
        traverse(store)
        return checkedNodes;
      },
      handleCheckChange(data, checked){
        this.selectNode = this.getSimpleCheckedNodes(this.$refs.tree.store);
        let code = [] , deptNmae = [];
        this.selectNode.forEach(t => {
          code.push(t.code);
          deptNmae.push(t.label);
        });
        this.departmentNo = code.join(",");
        this.department = deptNmae.join(",");
        // this.selectNode = this.formatToTree(selectData);
        // if(checked === true){
        //   this.checkId=data.id;
        //   this.departmentNo=data.code;
        //   this.department=data.label;
        //   // this.$refs.tree.setCheckedKeys([data.id]);
        // }else{
        //   if(this.checkId === data.id) {
        //     this.checkId='';
        //     this.departmentNo='';
        //     this.department='';
        //     // this.$refs.tree.setCheckedKeys([]);
        //   }
        // }
      },
      getChildrenMenu(depData){
        let depTree=[];
        depData.forEach(t=>{
          if(t.label.indexOf(this.department) != -1){
          depTree.push(t)
          }else{
            if(t.children && t.children && t.children.length){
              t.children = this.getChildrenMenu(t.children)
              if(t.children && t.children.length){
                depTree.push(t)
              }
            }
          }
        });
        return this.treeData=depTree;
      },
      handledHide(){
        this.$nextTick(()=>{
          if(!this.$refs.tree.getCheckedKeys().length){
            this.department="";
          }
        });
      },
      edit({row}){
       this.EditRow = typeof(row) == 'object' ? row || {} : {};
        this.dialogContent = {
          title: '编辑',
          componentName: 'add',
          width: '720px'
        }
        this.$refs.addDialog.show();
     },
      exportExcel() {
        let param = Object.assign({}, this.declareForm,{departmentNo:this.departmentNo});
        this.$ajax.get(this.$api.export.OecManagementListExport, param, {ignore: true, responseType: 'blob'}).then((res) => {
          if (res.data.type == 'application/json') {
            var reader = new FileReader();
            reader.onload = () => {
              var content = reader.result;//内容就在这里
              let json = JSON.parse(content)
              this.$message.error(json.message)
            };
            reader.readAsText(res.data);
          } else {
            const filename = 'OEC管理'
            const filetype = 'xlsx'
            let data = res.data;
            let url = window.URL.createObjectURL(data)
            let a = document.createElement('a')
            document.body.appendChild(a)
            a.href = url
            a.download = filename + '.' + filetype
            a.click()
            window.URL.revokeObjectURL(url)
          }
        });
      },
      exportMulti(){
        this.dialogContent = {
          title: '月份选择',
          componentName: 'month',
          width: '600px'
        }
        this.$refs.addDialog.show();
      },
      uploadPublishFile({ file }) {
        const params = new FormData();
        params.append('excelfile', file);
        this.$ajax.put(this.$api.manage.publish.import, params, { headers: { 'Content-Type': 'multipart/form-data;' } }).then((res) => {
          if (res.code === 0) {
            this.$message.success('上传成功');
            this.getList(1);
          }
        });
      },
      downloadPublishTemplate() {
        window.location.href = this.publishDownloadUrl;
      },

      declareRemind() {
        this.dialogContent = {
          title: '提醒人员确认',
          componentName: 'DeclareRemind',
          width: '720px'
        }
        this.$refs.addDialog.show()
      },
      confirmRemind() {
        this.dialogContent = {
          title: '提醒人员确认',
          componentName: 'ApproveRemind',
          width: '720px'
        }
        this.$refs.addDialog.show()
      }
    },
    watch:{
      department:{
        handler(val){
            // const depTree=_.cloneDeep(this.copyTreeData);
            // this.getChildrenMenu(depTree);
          if(!val){
            this.departmentNo="";
            this.$refs.tree&&this.$refs.tree.setCheckedKeys([]);
          }  
        },
        immediate:true
      }
    }
  }
</script>
<style scoped lang='scss'>
  .notice {
    .search {
      .atb-input{
        display: flex;
        flex-direction: column;
        .query-where{
          display: flex;
          .flex-form-item{
            display: flex;
            flex: 1;
            margin-bottom: 12px;
          }
          ::v-deep.el-form-item__content{
            flex: 1;
            .el-select, .el-autocomplete, .el-date-editor{
              width: 100%;
            }
          }
        }
        .query-operation {
          display: flex;
          flex-wrap: wrap;
          .flex-form-item {
            display: flex;
            flex: 1;
            max-width: 300px;
          }
          ::v-deep.el-form-item__label {
            white-space: nowrap;
          }
          ::v-deep.el-form-item__content{
            flex: 1;
            .el-select, .el-autocomplete, .el-date-editor {
              width: 100%;
            }
            .el-date-editor {
              min-width: 120px;
            }
            .el-select {
              min-width: 80px;
            }
          }
        }
      }
     
    }
    height: 100%;
    .atb-content-bg {
      margin-top: 15px;
      padding: 20px;
      flex: 1;
    }
    ::v-deep .tab{
      margin-top: -3px;
    }
    ::v-deep .el-dialog__body{
      padding-top: 33px !important;
      text-align: center;
      h2{
        font-size: 18px;
        color: $--color-text-primary;
        font-weight: bold;
        margin-bottom: 10px;
      }
      p{
        color: $--color-text-regular;
      }
    }
    ::v-deep .el-dialog__footer{
      text-align: center;
    }
  }
</style>
<style>
  .declare-dep{
    height: 350px;
    width: 350px;
    overflow: auto;
  }
</style>